type JSONData = Record<string, object>;

const jsonFiles = import.meta.glob<JSONData>('./**/*.json', { eager: true });

export function getData(folder: string, file: string): JSONData {
  const path = `./${folder}/${file}.json`;

  if (jsonFiles[path]) {
    return (jsonFiles[path] as { default: JSONData }).default;
  }

  const fallback = `./defaults/${file}.json`;

  if (jsonFiles[fallback]) {
    return (jsonFiles[fallback] as { default: JSONData }).default;
  }

  throw new Error(`JSON not found: ${folder}/${file}`);
}
